/**
 * Shared canvas pattern utilities for LED screens and projectors
 * Provides reusable test patterns and input sources
 */

export function createBorder(ctx, x, y, width, height, borderWidth, borderColor = '#FF6DF0') {
  // Draw border around the rectangle
  ctx.strokeStyle = borderColor;
  ctx.lineWidth = borderWidth;
  ctx.strokeRect(x, y, width, height);
}

/**
 * Draw the Disguise logo on a canvas context
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {number} x - X position (center)
 * @param {number} y - Y position (center)
 */
export function drawDisguiseLogo(ctx, width, height, x, y, textColor = 'white') {
  const logoW = 120.049;
  const logoH = 28.1768;

  ctx.save();

  const logoAspect = logoW / logoH;
  const canvasAspect = width / height;

  let scale;
  if (canvasAspect > logoAspect) {
    scale = (height * 0.3) / logoH;
  } else {
    scale = (width * 0.3) / logoW;
  }

  ctx.translate(x + width / 2, y + height / 2);
  ctx.scale(scale, scale);

  ctx.translate(-logoW / 2, -logoH / 2);

  const path1 = new Path2D(
    'M0 28.1768V0.75H0.0205137L3.17963 3.01677V26.0537L0 28.1768ZM6.86729 23.6012L10.0367 21.4934V7.45173L6.90318 5.36959L6.86729 23.6012ZM13.7587 19.0282L16.8922 16.8486V12.1151L13.7125 9.83293L13.7587 19.0282Z'
  );
  ctx.fillStyle = '#FF6DF0';
  ctx.fill(path1);

  const path2 = new Path2D(
    'M56.8772 13.1877C54.5591 12.7467 53.4616 12.5108 53.4616 11.3671C53.4616 10.2902 54.3796 9.74654 55.6617 9.74654C57.1182 9.74654 58.0208 10.5671 58.1593 11.7466H61.0979C61.0568 9.06959 58.9593 7.35156 55.6617 7.35156C52.3641 7.35156 50.4461 9.11061 50.4461 11.5876C50.4461 14.4237 52.5231 15.1827 54.8822 15.6237C57.2208 16.0853 58.3593 16.3212 58.3593 17.5007C58.3593 18.5982 57.3387 19.1982 55.9592 19.1982C54.2411 19.1982 53.1642 18.2597 53.0616 16.9007L50.123 16.8597C50.1435 19.6957 52.359 21.5778 55.9181 21.5778C59.1952 21.5778 61.3543 19.7777 61.3748 17.1622C61.3953 14.3467 59.2773 13.6236 56.8772 13.1877ZM31.25 7.46888H36.3477V7.46375C40.7017 7.46375 43.5993 10.3408 43.5993 14.4384C43.5993 18.536 40.7017 21.4541 36.3477 21.4541H31.25V7.46888ZM34.2501 18.9566H36.3477V18.9617C39.0247 18.9617 40.5222 17.1206 40.5222 14.4435C40.5222 11.7665 39.0247 9.96642 36.3477 9.96642H34.2501V18.9566ZM45.1068 7.46775H48.1018V21.453H45.1068V7.46775ZM73.3344 16.0648H69.8574L69.8471 16.0596V13.68H76.1038V21.4547H74.0063L73.7088 19.7777C72.9703 20.7573 71.6113 21.5778 69.6317 21.5778C65.6367 21.5778 62.9801 18.7623 62.9801 14.4647C62.9801 10.1671 65.6162 7.35156 69.9138 7.35156C73.2883 7.35156 75.6679 9.4337 76.0269 12.4492H73.0319C72.6729 10.9107 71.5549 9.89013 69.8368 9.89013C67.4983 9.89013 66.0418 11.7671 66.0418 14.4647C66.0418 17.1622 67.4419 19.0392 69.8368 19.0392C71.4369 19.0392 73.0524 18.2033 73.3344 16.2443V16.0648ZM86.6729 15.5809C86.6729 17.7964 85.8524 18.9965 83.9138 18.9965C81.9753 18.9965 81.1752 17.7964 81.1752 15.5809V7.46775H78.1751V15.4219C78.1751 19.3965 80.1547 21.5761 83.9087 21.5761C87.6627 21.5761 89.6628 19.3965 89.6628 15.4219V7.46775H86.6678V15.5809H86.6729ZM92.1561 7.46775H95.1511V21.453H92.1561V7.46775ZM103.874 13.1877C101.556 12.7467 100.459 12.5108 100.459 11.3671C100.459 10.2902 101.377 9.74654 102.659 9.74654C104.115 9.74654 105.018 10.5671 105.156 11.7466H108.095C108.054 9.06959 105.957 7.35156 102.659 7.35156C99.3614 7.35156 97.4433 9.11061 97.4433 11.5876C97.4433 14.4237 99.5203 15.1827 101.879 15.6237C104.218 16.0853 105.356 16.3212 105.356 17.5007C105.356 18.5982 104.336 19.1982 102.956 19.1982C101.238 19.1982 100.161 18.2597 100.059 16.9007L97.1202 16.8597C97.1408 19.6957 99.3562 21.5778 102.915 21.5778C106.192 21.5778 108.351 19.7777 108.372 17.1622C108.393 14.3467 106.274 13.6236 103.874 13.1877ZM113.438 15.6425V18.8785H120.049V21.4581H110.438V7.46775H119.828V10.0474H113.438V13.186H118.633V15.6425H113.438Z'
  );
  ctx.fillStyle = textColor;
  ctx.fill(path2);
  ctx.restore();
}

/**
 * Draw Input Source 1 (grid with circles)
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {number} x - X position (0 for full canvas)
 * @param {number} y - Y position (0 for full canvas)
 */
export function drawInputSource1(ctx, width, height, x = 0, y = 0, invert = false) {
  // Draw white background
  ctx.fillStyle = invert ? 'black' : 'white';
  ctx.fillRect(x, y, width, height);

  createBorder(ctx, x, y, width, height, 4);

  // Draw grid lines
  ctx.strokeStyle = '#bdbdbd';
  ctx.lineWidth = 1;
  const gridDivs = 10;
  for (let i = 0; i <= gridDivs; i++) {
    // Vertical lines
    ctx.beginPath();
    ctx.moveTo(x + (i * width) / gridDivs, y);
    ctx.lineTo(x + (i * width) / gridDivs, y + height);
    ctx.stroke();
    // Horizontal lines
    ctx.beginPath();
    ctx.moveTo(x, y + (i * height) / gridDivs);
    ctx.lineTo(x + width, y + (i * height) / gridDivs);
    ctx.stroke();
  }

  // Draw center lines (thicker)
  ctx.strokeStyle = '#bdbdbd';
  ctx.lineWidth = 3;
  // Vertical center
  ctx.beginPath();
  ctx.moveTo(x + width / 2, y);
  ctx.lineTo(x + width / 2, y + height);
  ctx.stroke();
  // Horizontal center
  ctx.beginPath();
  ctx.moveTo(x, y + height / 2);
  ctx.lineTo(x + width, y + height / 2);
  ctx.stroke();

  // Draw center circle
  ctx.strokeStyle = '#bdbdbd';
  ctx.lineWidth = 1.5;
  const circleRadius = height / 2;
  ctx.beginPath();
  ctx.arc(x + width / 2, y + height / 2, circleRadius, 0, 2 * Math.PI);
  ctx.stroke();

  // Draw logo
  drawDisguiseLogo(ctx, width, height, x, y, invert ? 'white' : 'black');
}

/**
 * Draw Input Source 2 (colored gradient grid)
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {number} x - X position (0 for full canvas)
 * @param {number} y - Y position (0 for full canvas)
 * @param {number} gridDivs - Number of grid divisions (default 10)
 */
export function drawInputSource2(ctx, width, height, x = 0, y = 0, gridDivs = 10) {
  const blockWidth = width / gridDivs;
  const blockHeight = height / gridDivs;

  // Corner colors for bilinear interpolation
  const c00 = { r: 255, g: 0, b: 0 }; // Top-left: Red
  const c10 = { r: 0, g: 255, b: 0 }; // Top-right: Green
  const c01 = { r: 255, g: 0, b: 255 }; // Bottom-left: Magenta
  const c11 = { r: 0, g: 0, b: 255 }; // Bottom-right: Blue

  for (let j = 0; j < gridDivs; j++) {
    for (let i = 0; i < gridDivs; i++) {
      const nx = i / (gridDivs - 1);
      const ny = j / (gridDivs - 1);

      // Bilinear interpolation for color
      const r = Math.round((1 - ny) * ((1 - nx) * c00.r + nx * c10.r) + ny * ((1 - nx) * c01.r + nx * c11.r));
      const g = Math.round((1 - ny) * ((1 - nx) * c00.g + nx * c10.g) + ny * ((1 - nx) * c01.g + nx * c11.g));
      const b = Math.round((1 - ny) * ((1 - nx) * c00.b + nx * c10.b) + ny * ((1 - nx) * c01.b + nx * c11.b));

      ctx.fillStyle = `rgb(${r},${g},${b})`;
      ctx.fillRect(x + i * blockWidth, y + j * blockHeight, blockWidth, blockHeight);
    }
  }

  // Draw grid lines between blocks
  ctx.strokeStyle = '#fff';
  ctx.lineWidth = 1;
  for (let i = 1; i < gridDivs; i++) {
    // Vertical
    ctx.beginPath();
    ctx.moveTo(x + i * blockWidth, y);
    ctx.lineTo(x + i * blockWidth, y + height);
    ctx.stroke();
    // Horizontal
    ctx.beginPath();
    ctx.moveTo(x, y + i * blockHeight);
    ctx.lineTo(x + width, y + i * blockHeight);
    ctx.stroke();
  }

  // Draw corner labels
  ctx.fillStyle = 'white';
  ctx.font = '30px Arial';

  // Top-left
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  ctx.fillText('0,0', x + 10, y + 10);

  // Top-right
  ctx.textAlign = 'right';
  ctx.textBaseline = 'top';
  ctx.fillText('1,0', x + width - 10, y + 10);

  // Bottom-left
  ctx.textAlign = 'left';
  ctx.textBaseline = 'bottom';
  ctx.fillText('0,1', x + 10, y + height - 10);

  // Bottom-right
  ctx.textAlign = 'right';
  ctx.textBaseline = 'bottom';
  ctx.fillText('1,1', x + width - 10, y + height - 10);

  // Draw logo
  drawDisguiseLogo(ctx, width, height, x, y);
}

/**
 * Draw color bars test pattern
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {number} x - X position (0 for full canvas)
 * @param {number} y - Y position (0 for full canvas)
 */
export function drawColorBars(ctx, width, height, x = 0, y = 0) {
  // Standard color bars: White, Yellow, Cyan, Green, Magenta, Red, Blue, Black
  const colors = [
    '#FFFFFF', // White
    '#FFFF00', // Yellow
    '#00FFFF', // Cyan
    '#00FF00', // Green
    '#FF00FF', // Magenta
    '#FF0000', // Red
    '#0000FF', // Blue
    '#000000', // Black
  ];

  const barWidth = width / colors.length;

  colors.forEach((color, index) => {
    ctx.fillStyle = color;
    ctx.fillRect(x + index * barWidth, y, barWidth, height);
  });
  drawDisguiseLogo(ctx, width, height, x, y);

  // Add white border
  ctx.strokeStyle = 'white';
  ctx.lineWidth = 2;
  ctx.strokeRect(x, y, width, height);
}

/**
 * Draw crosshatch test pattern
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {number} x - X position (0 for full canvas)
 * @param {number} y - Y position (0 for full canvas)
 * @param {number} spacing - Spacing between crosshatch lines (default 20)
 */
export function drawCrosshatch(ctx, width, height, x = 0, y = 0, spacing = 20) {
  // Fill with white background
  ctx.fillStyle = 'white';
  ctx.fillRect(x, y, width, height);

  // Draw crosshatch pattern
  ctx.strokeStyle = '#000000';
  ctx.lineWidth = 1;

  // Vertical lines
  for (let i = 0; i <= width; i += spacing) {
    ctx.beginPath();
    ctx.moveTo(x + i, y);
    ctx.lineTo(x + i, y + height);
    ctx.stroke();
  }

  // Horizontal lines
  for (let i = 0; i <= height; i += spacing) {
    ctx.beginPath();
    ctx.moveTo(x, y + i);
    ctx.lineTo(x + width, y + i);
    ctx.stroke();
  }

  // Draw center crosshairs (thicker)
  ctx.strokeStyle = '#FF0000';
  ctx.lineWidth = 3;

  // Vertical center line

  // Horizontal center line
  ctx.moveTo(x, y + height / 2);
  ctx.lineTo(x + width, y + height / 2);
  ctx.stroke();

  // Add corner markers
  ctx.fillStyle = '#FF0000';
  const markerSize = 10;

  // Corner markers
  ctx.fillRect(x, y, markerSize, markerSize);
  ctx.fillRect(x + width - markerSize, y, markerSize, markerSize);
  ctx.fillRect(x, y + height - markerSize, markerSize, markerSize);
  ctx.fillRect(x + width - markerSize, y + height - markerSize, markerSize, markerSize);

  drawDisguiseLogo(ctx, width, height, x, y, 'black');
}

/**
 * Draw a blank white rectangle
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {number} x - X position (0 for full canvas)
 * @param {number} y - Y position (0 for full canvas)
 */
export function drawBlankGrid(ctx, width, height, x = 0, y = 0) {
  ctx.fillStyle = 'white';
  ctx.fillRect(x, y, width, height);

  drawDisguiseLogo(ctx, width, height, x, y);
}
